import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete",
  "use": "icon-delete-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-delete\">\n  <g id=\"icon-delete_组_5641\" data-name=\"组 5641\" transform=\"translate(0)\">\n    <path id=\"icon-delete_路径_9246\" data-name=\"路径 9246\" d=\"M-1156.129-14.272h-2.912V-16.6h-10.133v2.327h-2.955v1.584h1.563V-.6h12.875V-12.688h1.563Zm-11.445-.742h6.933v.742h-6.933Zm8.283,12.832h-9.675v-10.5h9.675Z\" transform=\"translate(1172.129 16.599)\" fill=\"#becbdc\" />\n    <rect id=\"icon-delete_矩形_2364\" data-name=\"矩形 2364\" width=\"1.593\" height=\"7.588\" transform=\"translate(8.81 5.79)\" fill=\"#b0c1d8\" />\n    <rect id=\"icon-delete_矩形_2365\" data-name=\"矩形 2365\" width=\"1.593\" height=\"7.588\" transform=\"translate(5.608 5.79)\" fill=\"#b0c1d8\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/delete.svg
// module id = Imjp
// module chunks = 102